import { lazy, type ComponentType } from "react";
import type { AffiliateVariantProps } from "@/components/variations/affiliate-types";
import { DesignShell } from "./design-shell";

const affiliates: Record<string, ComponentType<AffiliateVariantProps>> = {
  v1: lazy(() =>
    import("@/components/variations/v1/V1Affiliate").then((m) => ({
      default: m.V1Affiliate,
    })),
  ),
  v2: lazy(() =>
    import("@/components/variations/v2/V2Affiliate").then((m) => ({
      default: m.V2Affiliate,
    })),
  ),
  v3: lazy(() =>
    import("@/components/variations/v3/V3Affiliate").then((m) => ({
      default: m.V3Affiliate,
    })),
  ),
  v4: lazy(() =>
    import("@/components/variations/v4/V4Affiliate").then((m) => ({
      default: m.V4Affiliate,
    })),
  ),
  v5: lazy(() =>
    import("@/components/variations/v5/V5Affiliate").then((m) => ({
      default: m.V5Affiliate,
    })),
  ),
  v6: lazy(() =>
    import("@/components/variations/v6/V6Affiliate").then((m) => ({
      default: m.V6Affiliate,
    })),
  ),
  v7: lazy(() =>
    import("@/components/variations/v7/V7Affiliate").then((m) => ({
      default: m.V7Affiliate,
    })),
  ),
  v8: lazy(() =>
    import("@/components/variations/v8/V8Affiliate").then((m) => ({
      default: m.V8Affiliate,
    })),
  ),
  v9: lazy(() =>
    import("@/components/variations/v9/V9Affiliate").then((m) => ({
      default: m.V9Affiliate,
    })),
  ),
};

export function AffiliateShell(props: AffiliateVariantProps) {
  return <DesignShell componentMap={affiliates} componentProps={props} />;
}
